import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import sv from './locales/sv.json'
import no from './locales/no.json'
import da from './locales/da.json'
import fi from './locales/fi.json'

const STORAGE_KEY = 'nq_lang'
const SUPPORTED = ['sv', 'no', 'da', 'fi']

export const LANGUAGE_LABELS = {
  sv: '🇸🇪 Svenska',
  no: '🇳🇴 Norsk',
  da: '🇩🇰 Dansk',
  fi: '🇫🇮 Suomi',
}

function detectLanguage() {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored && SUPPORTED.includes(stored)) return stored
  const browser = navigator.language?.split('-')[0]
  if (SUPPORTED.includes(browser)) return browser
  return 'sv'
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      sv: { translation: sv },
      no: { translation: no },
      da: { translation: da },
      fi: { translation: fi },
    },
    lng: detectLanguage(),
    fallbackLng: 'sv',
    interpolation: { escapeValue: false },
  })

export function setLanguage(lang) {
  if (!SUPPORTED.includes(lang)) return
  localStorage.setItem(STORAGE_KEY, lang)
  i18n.changeLanguage(lang)
}

export { SUPPORTED }
export default i18n
